import { Store } from "./last-action.store";
import * as Selectors from "./last-action.selectors";
import { setLastAction } from "./last-action.actions";
import { lastActionMiddleware } from "./last-action.reducers";
const publicActions = { setLastAction };
export const LastAction = {
    Store,
    Effects: {},
    Selectors,
    Actions: publicActions,
    Middleware: { lastActionMiddleware },
};
